/**
 * Created by mateo on 6/29/17.
 */
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'fechasFilter', standalone: false})

export class FechasNivelacionesPipe implements PipeTransform {
    transform(array, fecha) {
        const res = array.find(obj => obj.fecha == fecha);
        return res;
    }
}